module.exports = __webpack_public_path__ + "static/img/page2.6ac14c85.jpg";